import React, { Component } from 'react';
import { connect } from 'react-redux';
import twemoji from 'twemoji';
import { fromCodePoint } from '../../../../common/emojify';

// http://unicode.org/emoji/charts/full-emoji-list.html
const Emojis = [
    { title: 'Uśmiechnięta twarz', code: '1f642' },
    { title: 'Uśmiechnięta twarz odwrócona do góry nogami', code: '1f643' },
    { title: 'Uśmiech z sercem', code: '1f60d' },
    { title: 'Uśmiech w okularach', code: '1f60e' },
    { title: 'Ulga', code: '1f60c' },
    { title: 'Uśmiechnięta twarz ze zmrużonymi oczami', code: '1f60f' },
    { title: 'Mrugnięcie z językiem', code: '1f61c' },
    { title: 'Zmrużone oczy z językiem', code: '1f61d' },
    { title: 'Śmiejąca się twarz', code: '1f600' },
    { title: 'Śmiech ze łzami', code: '1f602' },
    { title: 'Śmiech ze zmrużonymi oczami', code: '1f606' },
    { title: 'Śmiech z halo', code: '1f607' },
    { title: 'Śmiech z rogami', code: '1f608' },
    { title: 'Latarnia z dynii', code: '1f383' },
    { title: 'Zakryte usta', code: '1f92d' },
    { title: 'Zakręcona twarz', code: '1f92a' },
    { title: 'Twarz z buziakiem', code: '1f618' },
    { title: 'Twarz z uniesioną brwią', code: '1f928' },
    { title: 'Twarz z gwiazdkami w oczach', code: '1f929' },
    { title: 'Ciii', code: '1f92b' },
    { title: 'Zamyślona twarz', code: '1f914' },
    { title: 'Zmartwiona twarz', code: '1f61f' },
    { title: 'Zmęczona twarz', code: '1f62b' },
    { title: 'Skrzywiona twarz', code: '1f62c' },
    { title: 'Smutna twarz', code: '1f61e' },
    { title: 'Głośno płacząca twarz', code: '1f62d' },
    { title: 'Eksplodująca głowa', code: '1f92f' },
    { title: 'Skrzywiona twarz', code: '1f612' },
    { title: 'Zła twarz', code: '1f620' },
    { title: 'Wściekła twarz', code: '1f621' },
    { title: 'Twarz z parą z nosa', code: '1f624' },
    { title: 'Straszna twarz', code: '1f628' },
    { title: 'Zmęczona twarz', code: '1f629' },
    { title: 'Niespokojna twarz z potem', code: '1f630' },
    { title: 'Krzycząca ze strachu twarz', code: '1f631' },
    { title: 'Śpiąca twarz', code: '1f634' },
    { title: 'Oszołomiona twarz', code: '1f635' },
    { title: 'Twarz z uciekającymi oczami', code: '1f644' },
    { title: 'Twarz z termometrem', code: '1f912' },
    { title: 'Machająca ręka', code: '1f44b' },
    { title: 'Ok', code: '1f44c' },
    { title: 'Kciuk w górę', code: '1f44d' },
    { title: 'Kciuk w dół', code: '1f44e' },
    { title: 'Słuchawka', code: '1f4de' },
    { title: 'Email', code: '1f4e7' },
    { title: 'Smartfon', code: '1f4f1' },
    { title: 'Tort urodzinowy', code: '1f382' },
    { title: 'Zapakowany prezent', code: '1f381' },
    { title: 'Choinka', code: '1f384' },
    { title: 'Bałwan', code: '26c4' },
    { title: 'Bałwan i śnieg', code: '2603' },
    { title: 'Święty Mikołaj', code: '1f385' },
    { title: 'Słońce', code: '2600' },
    { title: 'Pisząca ręka', code: '270d' },
    { title: 'Filiżanka herbaty', code: '1f375' },
    { title: 'Gorąca filiżanka', code: '2615' },
    { title: 'Fistaszek', code: '2611' },
    { title: 'Znak zapytania', code: '2753' },
    { title: 'Wykrzyknik', code: '2757' },
    { title: 'Róża', code: '1f339' },
    { title: 'Serce', code: '2764' }
];

class EmojiPicker extends Component { 
    constructor(props) {
        super(props);

        this.onPasteEmoji = this.onPasteEmoji.bind(this);
    }

    onPasteEmoji(e) {
        e.preventDefault();
        
        if(this.props.onEmojiPick) {
            let target = e.target;
            while(target.tagName != 'BUTTON') target = target.parentElement;
            const emoji = target.dataset.value;
            this.props.onEmojiPick(emoji);
        }
    }

    render() {
        return (
            <div className="opl-widget-chat--dialog-emojis">
                {Emojis.map((emoji, i) => {
                    const icon = twemoji.parse(fromCodePoint(emoji.code), { folder: 'svg', ext: '.svg' });
                    // return (<a dangerouslySetInnerHTML={{__html: icon }} />);
                    return (<button key={i} className="emoji-button" title={emoji.title} data-value={fromCodePoint(emoji.code)} onClick={this.onPasteEmoji} dangerouslySetInnerHTML={{__html: icon }} />);
                })
                }
            </div>
        );
    }
}

export default connect()(EmojiPicker);
